
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/transactions",
      function () {
        return require("private-next-pages/transactions/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/transactions"])
      });
    }
  